import angular from 'angular';
import publishToMediaComponent from './publish-to-media.component';
import mediaAccount from '../media-account/media-account';
import 'angular-file-upload';

let publishToMediaModule = angular.module('publishToMedia', [
    mediaAccount,
    'angularFileUpload'
])

    .component('publishToMedia', publishToMediaComponent)

    .name;

export default publishToMediaModule;



// WEBPACK FOOTER //
// ./src/app/modules/publish-to-media/publish-to-media.js